import React from "react";
import styled from "styled-components";
import { certifications } from "../../data/constants";
import VerifiedIcon from "@mui/icons-material/Verified";
import ScrollReveal from "../ScrollReveal";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 80px 0 40px 0;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
`;

const Title = styled.div`
  font-size: 42px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const CertGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
  margin-top: 30px;
  padding: 0 16px;
`;

const CertCard = styled.a`
  display: flex;
  align-items: center;
  gap: 20px;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 16px;
  padding: 24px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 24px ${({ theme }) => theme.glow};

  &:hover {
    transform: translateY(-4px);
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 8px 32px ${({ theme }) => theme.glow};
  }
`;

const CertImage = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;
  flex-shrink: 0;
`;

const CertBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CertName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.4;
`;

const CertIssuer = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.primary};
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CertDate = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.text_secondary};
`;

const Certifications = () => {
  return (
    <Container id="certifications">
      <Wrapper>
        <ScrollReveal direction="down" index={0}>
          <Title>Certifications</Title>
        </ScrollReveal>
        <ScrollReveal direction="down" index={1}>
          <Desc>
            Professional certifications that validate my technical expertise.
          </Desc>
        </ScrollReveal>
        <CertGrid>
          {certifications.map((cert, idx) => (
            <ScrollReveal key={cert.id} direction="down" index={idx + 2}>
              <CertCard
                href={cert.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <CertImage src={cert.image} alt={cert.name} />
                <CertBody>
                  <CertName>{cert.name}</CertName>
                  <CertIssuer>
                    <VerifiedIcon sx={{ fontSize: 16 }} />
                    {cert.issuer}
                  </CertIssuer>
                  <CertDate>{cert.date}</CertDate>
                </CertBody>
              </CertCard>
            </ScrollReveal>
          ))}
        </CertGrid>
      </Wrapper>
    </Container>
  );
};

export default Certifications;
